module.exports = __webpack_public_path__ + "img/logo.491f96bf.jpg";